import React from 'react';
import SortableTable from '../SortableTable';

const GIPromotersAndPointsTables = ({
  filteredFormData,
  formData,
  selectedPromoters,
  selectedDates,
  selectedInterventionPoints,
  selectedShopSigns,
  variant = 'main' // 'main' (two columns) | 'sidebar' (stacked)
}) => {
  const hasActiveFilters = selectedPromoters.length > 0 || selectedDates.length > 0 || selectedInterventionPoints.length > 0 || selectedShopSigns.length > 0;

  return (
    <div className={variant === 'sidebar' ? 'space-y-6' : 'mb-6 grid grid-cols-1 lg:grid-cols-2 gap-6'}>
      {/* Liste des promoteurs */}
      <div>
        <h3 className="text-lg font-semibold mb-2 text-gray-700 dark:text-gray-300">
          Promoteurs
          {hasActiveFilters ? (
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
              ({filteredFormData.metadata.promoters_count} sur {formData.metadata.promoters_count} total)
            </span>
          ) : (
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
              ({filteredFormData.metadata.promoters_count})
            </span>
          )}
        </h3>
        <div className={`${variant === 'sidebar' ? 'h-56' : 'h-48'} bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg`}>
          <SortableTable
            data={filteredFormData.data.promoters}
            columns={[
              {
                key: 'PromoterName',
                label: 'Nom du promoteur',
                render: (item) => item.Name || item.PromoterName
              }
            ]}
            emptyMessage="Aucun promoteur trouvé"
            countLabel={`${filteredFormData.data.promoters.length} promoteur${filteredFormData.data.promoters.length > 1 ? 's' : ''}`}
            exportable={true}
            exportFilename="promoteurs.csv"
          />
        </div>
      </div>

      {/* Liste des points d'intervention */}
      <div>
        <h3 className="text-lg font-semibold mb-2 text-gray-700 dark:text-gray-300">
          Points d'intervention
          {hasActiveFilters ? (
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
              ({filteredFormData.data.interventionPoints ? filteredFormData.data.interventionPoints.length : 0} sur {formData.data.interventionPoints ? formData.data.interventionPoints.length : 0} total)
            </span>
          ) : (
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
              ({filteredFormData.data.interventionPoints ? filteredFormData.data.interventionPoints.length : 0})
            </span>
          )}
        </h3>
        <div className={`${variant === 'sidebar' ? 'h-56' : 'h-48'} bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg`}>
          <SortableTable
            data={filteredFormData.data.interventionPoints || []}
            columns={[
              {
                key: 'Name',
                label: 'Nom du point d\'intervention',
                render: (item) => item.Name
              }
            ]}
            emptyMessage="Aucun point d'intervention trouvé"
            countLabel={`${filteredFormData.data.interventionPoints ? filteredFormData.data.interventionPoints.length : 0} point${(filteredFormData.data.interventionPoints ? filteredFormData.data.interventionPoints.length : 0) > 1 ? 's' : ''} d'intervention`}
            exportable={true}
            exportFilename="points-intervention.csv"
          />
        </div>
      </div>
    </div>
  );
};

export default GIPromotersAndPointsTables;